import { useTranslation } from "react-i18next"

import { Loader2 } from "@/components/icons"

export function LoadingState() {
  const { t } = useTranslation()

  return (
    <div className="text-muted-foreground flex h-64 flex-col items-center justify-center">
      <Loader2 className="mb-3 h-6 w-6 animate-spin sm:h-8 sm:w-8" />
      <p className="text-sm font-medium">
        {t("filepicker.loading", { defaultValue: "Loading..." })}
      </p>
    </div>
  )
}
